import { useRef } from 'react'

export const useUploadButtonsService = ({ feedButtonFilled, reelButtonFilled, feedFileId, reelFileId, fileId, handleFileSelect }) => {
  const fileInputRef = useRef(null)
  const uploadParamsRef = useRef(null)
    
  const handleButtonClick = (e, placementType) => {
    e.preventDefault()
    e.stopPropagation()
      
    // Determine if we're replacing existing file based on button state
    const isReplace = (placementType === 'feed' && feedButtonFilled) || (placementType === 'reel' && reelButtonFilled)
    let fileToReplaceId = null
      
    if (isReplace) {
      if (placementType === 'feed' && feedFileId) {
        fileToReplaceId = feedFileId
      } else if (placementType === 'reel' && reelFileId) {
        fileToReplaceId = reelFileId
      } else {
        // If no specific file ID, use current file ID (replacing current file)
        fileToReplaceId = fileId
      }
    }
      
    // Store upload parameters
    uploadParamsRef.current = {
      fileId,
      placementType,
      isReplace,
      fileToReplaceId
    }
      
    // Trigger file input click
    fileInputRef.current?.click()
  }
    
  const onFileInputChange = (event) => {
    if (uploadParamsRef.current && handleFileSelect) {
      handleFileSelect(event, uploadParamsRef.current)
      uploadParamsRef.current = null
    }
    // Reset input
    if (event.target) {
      event.target.value = ''
    }
  }

  return {
    fileInputRef,
    handleButtonClick,
    onFileInputChange,
  }
}